var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('transition',{attrs:{"name":"sidenav-transition","mode":"out-in"}},[_c('side-nav')],1),_c('main',{staticClass:"l-default"},[_vm._t("default")],2),_c('assistance'),_c('messages'),_c('modals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }